'use strict';

var Controller = require('./MapController');

function MapDirective () {

  function compile () {
    return  {
      pre: function () {},
      post: function (scope, el, attr, ctrl) {
        ctrl.redrawMap();
      }
    };
  }

  return {
    controller: Controller,
    controllerAs: 'mapCtrl',
    compile: compile,
    templateUrl: 'manager/processing/map/map.tpl.html'
  };
}

MapDirective.$inject = [];
module.exports = MapDirective;


// WEBPACK FOOTER //
// ./src/app/manager/processing/map/MapDirective.js